import { type Ref, forwardRef } from "react";
import type { SVGProps } from "react";
const ChevronDown = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={24}
    height={24}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-5.95-5.108a6 6 0 0 0-3.467-1.095c-2.525 0-3.968 1.551-4.517 3.75H6.562l-.757 1.25h2.05a11 11 0 0 0-.045 1.226H6.107l-.799 1.25H7.91c.381 2.614 1.851 4.55 4.673 4.55 1.447 0 2.776-.509 3.815-1.358l-.945-1.634a4.16 4.16 0 0 1-2.87 1.143c-1.788 0-2.547-1.123-2.798-2.7h3.02l.895-1.25H9.685l-.002-.213q0-.526.045-1.014h3.177l.847-1.25h-3.78c.369-1.143 1.143-1.9 2.61-1.9.954 0 1.832.32 2.535.857z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(ChevronDown);
export default ForwardRef;
